export default __webpack_public_path__ + "static/media/Chewy-Regular.e94e4ae6.ttf";